import React, { useState } from 'react';
import InfoOverlay from './InfoOverlay';

export default function InfoButton(props) {
    const [toggled, setToggled] = useState(false);

    function toggle() {
        setToggled(!toggled);
    }

    return (
        <div className="h-[24px] w-[24px] flex items-center">
            <img height="20px" width="20px" src={`${process.env.PUBLIC_URL}/assets/images/info.png`} alt="Event info button" onClick={toggle} />
            {toggled &&
                <InfoOverlay data={props.data} toggle={toggle} />
            }
        </div>
    );
}
